
import { Loader2 } from "lucide-react";

const RequestsLoading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  );
};

export default RequestsLoading;
